import { Popup, TPopupComponent } from '../../popup/popup.abstract.tsx';
import { TPopupDefaultActions } from '../../popup/services/popup.service.ts';
import { FC, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material';
import { PopupContent } from './popupContent.tsx';
import { EmailTrackingByDocumentQueryVariables } from '../../../../graphql/generatedModel.ts';
import { EmailTrackingByDocumentRes } from '../services/emailTracking.service.ts';

export class EmailTrackingPopup extends Popup<IEmailTrackingPopup> {
  Component: FC<TPopupComponent>;
  constructor() {
    super();
    const stream = this.innerStream;
    this.Component = () => {
      const { t } = useTranslation();
      const SWrapper = useMemo(() => {
        return styled(this.Wrapper)(() => ({
          '& > div > div': { maxWidth: 1310 },
        }));
      }, []);
      const [queryParams, setQueryParams] =
        useState<IEmailTrackingPopup['params']['queryParams']>(null);
      const [receivedData, setReceivedData] =
        useState<IEmailTrackingPopup['params']['receivedData']>(null);
      useEffect(() => {
        stream
          .actionListener('open')
          .subscribe(({ params: { queryParams = null, receivedData = null } }) => {
            setQueryParams(queryParams);
            setReceivedData(receivedData);
          });
      }, []);
      return (
        <SWrapper fullWidth stream={stream} popupTitle={t('common.history')}>
          <PopupContent {...{ queryParams, receivedData }} />
        </SWrapper>
      );
    };
  }
}

export interface IEmailTrackingPopup {
  action: TPopupDefaultActions;
  params: QueryParamsType | ReceivedDataType;
}

type QueryParamsType = {
  queryParams: EmailTrackingByDocumentQueryVariables | null;
  receivedData?: never;
};

type ReceivedDataType = {
  receivedData: EmailTrackingByDocumentRes | null;
  queryParams?: never;
};
